import { render, staticRenderFns } from "./CodigoSiscomIndex.vue?vue&type=template&id=7b812778"
import script from "./CodigoSiscomIndex.vue?vue&type=script&lang=js"
export * from "./CodigoSiscomIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports